module.exports = __webpack_public_path__ + "static/media/appstore_download_icon@2x.b48bb7ab.png";